import { render, staticRenderFns } from "./pledgeDetail.vue?vue&type=template&id=fa3a05f8&"
import script from "./pledgeDetail.vue?vue&type=script&lang=js&"
export * from "./pledgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./pledgeDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports